import { useState } from 'react';
import TimesheetAttachments from './TimesheetAttachments';
import TimesheetExpense from './TimesheetExpense';
import Card from '../../common/components/Card';
import { Tabs } from 'antd';
const { TabPane } = Tabs;

const TimesheetUploadsContainer = ({ timesheet, endDate, readonly }) => {
  const [defaultTab, setDefaultTab] = useState('1');
  return (
    <Card>
      <Tabs
        defaultActiveKey={defaultTab}
        onChange={e => {
          setDefaultTab(e);
        }}
      >
        <TabPane tab="Attachments" key="1">
          <div>
            <TimesheetAttachments timesheet={timesheet} endDate={endDate} readonly={readonly} />
          </div>
        </TabPane>
        <TabPane tab="Expenses" key="2">
          <div>
            <TimesheetExpense timesheet={timesheet} endDate={endDate} readonly={readonly} />
          </div>
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default TimesheetUploadsContainer;
